export default "__VITE_ASSET__DXZznZk0__"